import {ChangeDetectionStrategy, Component} from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `<router-outlet />`,
//  templateUrl: './app.component.html',
//  styleUrl: './app.component.css'
})
export class AppComponent {
  title = 'bailia';
}
